<template>
	<div>
		
	<v-data-table
		:headers="info_table.headers"
		:items="list_table"
		dense
		class="elevation-5"
		:options.sync="options"
	   	:server-items-length="total"
	   	:footer-props="{
	   		showFirstLastPage: true,
	   		itemsPerPageOptions: [15, 30],
	   		showCurrentPage: true
	   	}"
	   	loading-text="Loading... Please wait"
	   	:loading="false"
	    :height="layout_height+'px'"
	    fixed-header
	    fixed-body
	    item-key="index"
	>	
		<template v-slot:item.category="{ item }">
			<span :class="item.color">
				{{item.category}}
			</span>
		</template>
		<template v-slot:item.enable="{ item }">
			<span :class="item.enable ? 'primary--text' : 'secondary--text'">
				{{item.enable ? 'Active' : 'Inactive'}}
			</span>
		</template>
		<template v-slot:item.active="{ item }">
			<span :class="item.active ? 'primary--text' : 'secondary--text'">
				{{item.active ? 'Active' : 'Inactive'}}
			</span>
		</template>
		
		<template v-slot:item.content="{ item }">
			
			<v-btn
				x-small
				color="primary"
				@click="show_info(item.content)"
			>
				<v-icon
					x-small
					v-text="'mdi-information'"
				></v-icon>
			</v-btn>
			
		</template>
		<template v-slot:item.action="{ item }">
			
			<v-btn
				x-small
				color="primary"
				@click="show_info(item.analytics)"
			>
				<v-icon
					x-small
					v-text="'mdi-information'"
				></v-icon>
			</v-btn>
			
		</template>
	</v-data-table>
		<show_modal
			key="modal_table"
			:info_to_component = "info_component"
			@close_component = "info_component = $event" 
		></show_modal>
	</div>

</template>
<script>
	import show_modal from '@/components/info/show_modal.vue'

	export default{
		name: 'input_table',
		components:{
			show_modal
		}, // components
		props: [
			'info_table', 
			'list_table', 
			'layout_height'
		],
		/*
			// This is information you should receive
				info_table:{
					headers					
					options: {},
					total: 1,				
				},
			// items table
				list: [],
			// this is the height  of table
				layout_height: int, 

		*/
		data: (vm) => ({
			total: 1,
			options: { itemsPerPage: 30 },
			info_component: null,

		}), // data
		watch:{

		}, //watch

		created(){
			this.total = this.info_table.total;
			this.options = this.info_table.options;
		}, // created

		methods:{
			show_info(item){
				console.log(item , 'before open modal')
				if (item) {
					this.info_component = item;
				}
			}
		}, // methods
	};
</script>